<template>
    <div class="tooltip-select" v-on-clickaway="away">
        <div class="tooltip-select__container" :class="{'tooltip-select__container--open': mostrarTooltipSelect}">
            <v-select selectOnTab placeholder="Selecciona Bodega" v-model="itemSeleccionado" :label="this.label" :options="this.opciones" class="tooltip-select__select"></v-select>
            <button type="button" class="btn-light btn--text tooltip-select__confirm" :class="{'tooltip-select__confirm--active': itemSeleccionado}" @click="envioSeleccionado"><i class="fas fa-check-circle"></i></button>
        </div>
        <button type="button" class="btn-light btn--text" @click="toggleTooltipSelect"><i class="fas" :class="mostrarTooltipSelect?'fa-times-circle':'fa-arrow-circle-up'"></i></button>
    </div>
</template>

<script>
import { mixin as clickaway } from 'vue-clickaway';

export default {
    mixins: [ clickaway ],
    props: {
        opciones: {
            required: true
        },
        label: {
            required: false
        },
        rowIndex: {
            required: false
        },
        codigoProceso: {
            required: false
        }
    },
    data () {
        return {
            mostrarTooltipSelect: false,
            itemSeleccionado: null
        }
    },
    methods: {
        toggleTooltipSelect () {
            this.mostrarTooltipSelect = !this.mostrarTooltipSelect
        },
        envioSeleccionado () {
            if (this.itemSeleccionado !== null) {
                this.$emit('check', this.itemSeleccionado, this.rowIndex, this.codigoProceso)
                this.mostrarTooltipSelect = false
            }
        },
        away () {
            if (this.mostrarTooltipSelect) {
                this.mostrarTooltipSelect = false;
            }
        }
    },
    watch: {
        itemSeleccionado: function () {
            if (this.itemSeleccionado === null) {
                this.$emit('check', this.itemSeleccionado, this.rowIndex, this.codigoProceso)
            }
        }
    }
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/element/TooltipSelect.vue